import React from 'react';

const BreadCrumbNav = (props: { title: any; }) => {
  const { title } = props;

  return (
    <section className="page-title">
      <div
        className="bg-layer"
        style={{ backgroundImage: `url(assets/images/background/page-title.jpg)` }}
      ></div>
      <div className="auto-container">
        <div className="content-box">
          <h1>{title}</h1>
          <ul className="bread-crumb clearfix">
            <li>
              <a href="/">Home</a>
            </li>
            <li>{title}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default BreadCrumbNav;
